import React from 'react'

import LocationsAffected from '../../../locationsAffected'
import PaidLeaveTypes from '../tableCells/paidLeaveTypes'
import ExpandableTruncatedText from '../../../../../app/components/ExpandableTruncatedText'
import {
  FilterableTableHeader,
  SortableTableHeader
} from '../../../../../app/components/statelessDataTable/components/tableColumn'
import { formatDate } from '../../../../../common/helpers'
import PaidLeaveNotificationAddressModal from '../../../locationsAffected/notificationsModal/table'
import PaidLeaveNotificationContentModal from '../../notificationContentModal/index'
import { StyledSpan } from '../../../../../theme/Global'

const paidLeaveNotificationsTableColumns = ({
  sortOptions,
  filterOptions,
  eventHandlers
}) => ([
  {
    Header: () => (
      <SortableTableHeader
        field="dateOfChange"
        text="Date of Change"
        sortOptions={sortOptions}
        eventHandlers={eventHandlers}
      />
    ),
    accessor: 'dateOfChange',
    width: 100,
    minWidth: 0, // default
    maxWidth: 0, // default
    Cell: ({ cell }) => <div className="text">{formatDate(cell.row.original.dateOfChange)}</div>,
    canSort: true
  },
  {
    Header: () => (
      <SortableTableHeader
        field="locationsAffected"
        text="Locations Affected"
        sortOptions={sortOptions}
        eventHandlers={eventHandlers}
      />
    ),
    accessor: 'locations',
    width: 150,
    minWidth: 0, // default
    maxWidth: 0, // default
    Cell: ({ cell }) => (
      <LocationsAffected
        notification={cell.row.original}
        canOpen
        modal={<PaidLeaveNotificationAddressModal notification={cell.row.original} />}
      />
    ),
    canSort: true
  },
  {
    Header: () => (
      <SortableTableHeader
        field="jurisdiction"
        text="Jurisdiction"
        sortOptions={sortOptions}
        eventHandlers={eventHandlers}
      />
    ),
    accessor: 'jurisdictionName',
    width: 150,
    minWidth: 0, // default
    maxWidth: 0, // default
    Cell: ({ cell }) => (
      <StyledSpan data-testid="pl-notifications-jurisdiction-name">
        {cell.row.original.jurisdictionName}
      </StyledSpan>
    ),
    canSort: true
  },
  {
    Header: 'Update Description',
    accessor: 'update',
    width: 350,
    minWidth: 0, // default
    maxWidth: 0, // default
    Cell: ({ cell }) => (
      <ExpandableTruncatedText
        text={cell.row.original.content}
        truncateNumber={50}
        isNotMarkdown={false}
        modal={<PaidLeaveNotificationContentModal notification={cell.row.original} />}
      />
    ),
    canSort: false
  },
  {
    Header: () => (
      <FilterableTableHeader
        field="products"
        text={filterOptions.products && filterOptions.products.display ? filterOptions.products.display : 'Paid Leave Type'}
        selection={[
          ['Clear Filter', ''],
          ['Paid Sick Leave', 'paidSickLeave'],
          ['Paid Family and Medical Leave', 'paidFamilyMedicalLeave'],
          ['Paid Leave - Miscellaneous', 'paidLeaveMisc']
        ]}
        filterOptions={filterOptions}
        eventHandlers={eventHandlers}
      />
    ),
    accessor: 'products',
    width: 250,
    minWidth: 0, // default
    maxWidth: 0, // default
    Cell: ({ cell }) => (
      <PaidLeaveTypes
        products={cell.row.original.paidLeaveType}
      />
    ),
    canSort: false
  }
])

export default paidLeaveNotificationsTableColumns
